import script from "./NoActiveMemberships.vue?vue&type=script&setup=true&lang=js"
export * from "./NoActiveMemberships.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__